import { Component } from '@angular/core';

import {
  CamEventCardComponent,
  CamPlanningCalendarComponent,
  CamPlanningEditEventContent,
  CamPlanningSchedulerComponent,
  VisitStatusComponent,
} from '@camelot/planning';

import { TestIdDirective } from '@camelot/testing-harness';

@Component({
    imports: [
        CamEventCardComponent,
        CamPlanningCalendarComponent,
        CamPlanningEditEventContent,
        CamPlanningSchedulerComponent,
        TestIdDirective,
        VisitStatusComponent,
    ],
    template: `
    <cam-planning-calendar
      camTestId="cam-planning-calendar"
      planningId="e2e-planning-calendar"
      [events]="this.empty"
      [timeRanges]="this.empty"
      [addEventTemplate]="addEventTemplate"
    />
    <cam-planning-scheduler
      camTestId="cam-planning-scheduler"
      planningId="e2e-planning-scheduler"
      [events]="this.empty"
      [resources]="this.empty"
      [ressourceCard]="null"
      [timeRanges]="this.empty"
      [addEventTemplate]="addEventTemplate"
    />
    <cam-visit-status camTestId="cam-visit-status" [status]="1" />
    <app-calendar-event-card camTestId="app-calendar-event-card" [event]="this.event" />
    <cam-planning-edit-event-content camTestId="cam-planning-edit-event-content" />
    <ng-template #addEventTemplate>
      <div>add event</div>
    </ng-template>
  `
})
export class PlanningCase {
  public empty = [];
  public event = {
    endDate: '2026-01-01T11:00:00Z',
    id: 'event-1',
    startDate: '2026-01-01T10:00:00Z',
    title: 'Visit',
  } as never;
}
